<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <exportar-bdgd-data-table :items="items" :loading="loading" @rechargeTable="getExportacoes" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ExportacoesBdgdsService from '@/services/ExportacoesBdgdsService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      ExportarBdgdDataTable: () => import('@/components/geracao-bdgd/exportar-bdgd/ExportarBdgdDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    created() {
      this.refreshData(this.getExportacoes);
    },

    methods: {
      getExportacoes() {
        this.loading = true;

        ExportacoesBdgdsService.getExportacoes()
          .then((responseData) => {
            this.items = responseData;
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
